import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import useFullUrl from "web/core/shop/useFullUrl";
import Image from "theme/components/atoms/Image";

const isHexColor = (color) => /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);

const ColorSwatch = (props) => {
  return (
    <span
      className={classnames("option-picker__swatch-color")}
      aria-label={props.label}
      style={{ backgroundColor: props.value }}
    />
  );
};

const ImageSwatch = (props) => {
  const url = useFullUrl(props.value);
  return (
    <span className={classnames("option-picker__swatch-image")}>
      <Image src={url} alt={props.label} format="swatch" appearance="full" />
    </span>
  );
};

const Option = ({
  option,
  appearance = "default",
  onClick,
  selected = false,
  disabled = false,
  attribute,
}) => {
  const classes = classnames("option-picker__option", {
    [`option-picker__option--${appearance}`]: true,
    "option-picker__option--clickable": onClick,
    "option-picker__option--selected": selected,
    "option-picker__option--disabled": disabled,
  });
  return (
    <button
      className={classes}
      onClick={!disabled && onClick}
      disabled={disabled}
    >
      {attribute.code === "color" ? (
        <ColorSwatch value={option.label} label={option.label} />
      ) : option?.swatch?.value ? (
        isHexColor(option?.swatch?.value) ? (
          <ColorSwatch value={option.swatch.value} label={option.label} />
        ) : (
          <ImageSwatch value={option.swatch.value} label={option.label} />
        )
      ) : (
        option.label
      )}
    </button>
  );
};

Option.propTypes = {
  children: PropTypes.node,
  shape: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default Option;
